export default __webpack_public_path__ + "./fonts/radioCheckAccount.9969cff5.svg";